<template>
  <div
    class="typing-indicator"
    aria-live="polite"
    :aria-label="statusMessages[statusIndex]"
  >
    <transition name="status-fade" mode="out-in">
      <span :key="statusIndex" class="status-text">{{ statusMessages[statusIndex] }}</span>
    </transition>
    <div class="dots">
      <span class="dot" />
      <span class="dot" />
      <span class="dot" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatTypingIndicator',
  data() {
    return {
      statusIndex: 0,
      statusMessages: [
        'Analyzing the question...',
        'Preparing the answer...',
        'Validating the response...',
        'Almost there...',
      ],
      rotationTimer: null,
    };
  },
  mounted() {
    this.rotationTimer = setInterval(() => {
      this.statusIndex = (this.statusIndex + 1) % this.statusMessages.length;
    }, 2500);
  },
  beforeUnmount() {
    if (this.rotationTimer) {
      clearInterval(this.rotationTimer);
      this.rotationTimer = null;
    }
  },
};
</script>

<style scoped>
.typing-indicator {
  display: inline-flex;
  align-items: center;
  gap: 0.65rem;
  padding: 0.65rem 0.9rem;
  background: var(--card-bg);
  border: 1px solid var(--border-color);
  border-radius: 1rem 1rem 1rem 0.25rem;
  box-shadow: 0 2px 8px var(--shadow-color);
}

.status-text {
  font-size: 0.72rem;
  color: var(--text-secondary);
  white-space: nowrap;
}

.dots {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
}

.dot {
  width: 0.45rem;
  height: 0.45rem;
  border-radius: 50%;
  background: var(--text-tertiary);
  animation: typingBounce 1.2s ease-in-out infinite;
}

.dot:nth-child(2) {
  animation-delay: 0.15s;
}

.dot:nth-child(3) {
  animation-delay: 0.3s;
}

.status-fade-enter-active,
.status-fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}

.status-fade-enter-from,
.status-fade-leave-to {
  opacity: 0;
  transform: translateY(4px);
}

@keyframes typingBounce {
  0%, 60%, 100% {
    transform: translateY(0);
    opacity: 0.45;
  }
  30% {
    transform: translateY(-5px);
    opacity: 1;
  }
}

@media (max-width: 400px) {
  .typing-indicator {
    flex-direction: column;
    align-items: flex-start;
    gap: 0.4rem;
  }
}
</style>
